module.exports = __webpack_public_path__ + "static/media/part3.5bd471a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/partners/part3.png
// module id = 104
// module chunks = 0